// data shared in components: SortDropdown

import * as searchSetters from './store/searchStore-setters'
import * as search from './search'

const sortResults = (n) => {
  searchSetters.setNewSorting(n)
  // set page start to default
  searchSetters.resetPageStart()
  search.loadResults()
}

export default sortResults



// WEBPACK FOOTER //
// ./src/scripts/modules/sorting.js